module.exports = __webpack_public_path__ + "static/media/change_status_club_2.e908664f.png";